import React, { useState } from 'react';
import { ICON_NEW } from '../extras/icons';
import MainContent from '../layout/MainContent';
import UnitList from './units/UnitList';
import UnitForm from './units/UnitForm';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addUnitsAction } from '../../actions/unitsActions';
import { UNIDADES_CREAR } from '../../data/objects';
import AuthoritiesService from '../../services/AuthoritiesService';
//Función principal
const Units = () => {
    //Inicializo el state local
    const [show, setShow] = useState(false);
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo el insert
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addUnitsAction(handleOpen) );
    }
    //Nodos
    const nodes = [];
    //Actions
    const actions = [{
        title: 'NUEVO',
        css: 'success',
        icon: <ICON_NEW className="fa-sm text-white-50" />,
        handle: handleCreate,
        granted: authorities && AuthoritiesService.hasPermission(authorities, UNIDADES_CREAR)
    }];
    //Manejo la apertura de la ventana
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo el cierre de la ventana
    const handleClose = () => {
        setShow(false);
    }
    //Renderizo
    return (
        <React.Fragment>
            <MainContent 
                title='Unidades' 
                subtitle='Administración' 
                nodes={nodes}
                actions={actions}
                component={UnitList}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />

            <UnitForm
                show={show}
                handleClose={handleClose}
            />
        </React.Fragment>
    );
};

export default Units;